type SampleScene = {
    id: 'office' | 'carcrashscene' | 'drone' | 'drone-antep' | 'drone-antep-2' | 'drone-antep-3';
    name: string;
    filename: string;
    url: string;
    previewUrl: string;
    description: string;
    size: number;
};

const SAMPLE_SCENES: SampleScene[] = [{
    id: 'office',
    name: 'Office',
    filename: 'office.blgs',
    url: './static/files/office.blgs',
    previewUrl: './static/images/sample-office.jpg',
    description: 'Indoor workspace capture',
    size: 1364529026
}, {
    id: 'carcrashscene',
    name: 'Car Crash Scene',
    filename: 'carcrashscene.blgs',
    url: './static/files/carcrashscene.blgs',
    previewUrl: './static/images/sample-carcrashscene.jpg',
    description: 'Two-vehicle collision scene',
    size: 1810815858
}, {
    id: 'drone',
    name: 'Drone',
    filename: 'drone.blgs',
    url: './static/files/drone.blgs',
    previewUrl: './static/images/sample-drone.jpg',
    description: 'Outdoor aerial capture',
    size: 3745031765
}, {
    id: 'drone-antep',
    name: 'Drone Antep',
    filename: 'drone_antep.blgs',
    url: './static/files/drone_antep.blgs',
    previewUrl: './static/images/sample-drone-antep.jpg',
    description: 'Industrial aerial capture',
    size: 918573127
}, {
    id: 'drone-antep-2',
    name: 'Drone Antep 2',
    filename: 'drone_antep_2.blgs',
    url: './static/files/drone_antep_2.blgs',
    previewUrl: './static/images/sample-drone-antep-2.jpg',
    description: 'Industrial aerial capture',
    size: 1133890038
}, {
    id: 'drone-antep-3',
    name: 'Drone Antep 3',
    filename: 'drone_antep_3.blgs',
    url: './static/files/drone_antep_3.blgs',
    previewUrl: './static/images/sample-drone-antep-3.jpg',
    description: 'Industrial aerial capture',
    size: 759624836
}];

const SAMPLE_CACHE_NAME = 'biligoba-sample-scenes-v2';

export { SAMPLE_CACHE_NAME, SAMPLE_SCENES, SampleScene };
